import { useCallback, useMemo } from "react";

import { useStore } from "react-redux";

import { selectActiveLeadsType } from "app/pages/sales-intelligence/modules/leads-search";
import salesApiService from "app/pages/sales-intelligence/services/salesApiService";
import type { ContactsFlowStrategy } from "app/pages/sales-intelligence/sub-modules/contacts-search/context/ContactsFlowContext.types";
import { contactsQueryKeys } from "app/pages/sales-intelligence/sub-modules/contacts-search/query/queryKeys/queryKeyFactory";
import { selectContactSearchResultsDtoWithAggregation } from "app/pages/sales-intelligence/sub-modules/contacts-search/store/selectors";
import type { RootState } from "single-spa/store/types";

export const useAdvancedSearchContactsFlowStrategy = (): ContactsFlowStrategy => {
    const store = useStore<RootState>();

    const getRevealCacheKey = useCallback(() => {
        const state = store.getState();
        const leadType = selectActiveLeadsType(state);
        const dto = selectContactSearchResultsDtoWithAggregation(state);

        return contactsQueryKeys.tableData(leadType, dto);
    }, [store]);

    return useMemo<ContactsFlowStrategy>(() => {
        return {
            dataSource: {
                revealSingle: salesApiService.contactsSearch.revealSingleContact,
                revealMultiple: salesApiService.contactsSearch.revealContactsById,
                exportExcel: (dto) =>
                    salesApiService.contactsSearch.exportToExcel(dto, selectActiveLeadsType(store.getState())),
            },
            getRevealCacheKey,
        };
    }, [store, getRevealCacheKey]);
};
